import { z } from 'zod';
import { type Extensions, generateText, type JSONContent } from '@tiptap/core';
import BlockQuote from '@tiptap/extension-blockquote';
import CodeBlock from '@tiptap/extension-code-block-lowlight';
import Code from '@tiptap/extension-code';
import Link from '@tiptap/extension-link';
import Paragraph from '@tiptap/extension-paragraph';
import Typography from '@tiptap/extension-typography';
import Underline from '@tiptap/extension-underline';
import Document from '@tiptap/extension-document';
import Text from '@tiptap/extension-text';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Image from '@tiptap/extension-image';
import HardBreak from '@tiptap/extension-hard-break';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import BulletList from '@tiptap/extension-bullet-list';
import Heading from '@tiptap/extension-heading';
import HorizontalRule from '@tiptap/extension-horizontal-rule';

const extensions = [
  Document,
  Text,
  Bold,
  Italic,
  BlockQuote,
  CodeBlock,
  Code,
  Link,
  Paragraph,
  Typography,
  Underline,
  Image,
  HardBreak,
  ListItem,
  OrderedList,
  BulletList,
  Heading,
  HorizontalRule,
] satisfies Extensions;

/**
 * Generate a plaintext representation of a TipTap JSONContent object
 * @param content - The TipTap JSONContent object
 * @returns A plaintext representation of the content
 */
export function generateTextFromTipTapContent(content: JSONContent): string {
  return generateText(content, extensions, {
    blockSeparator: '\n\n',
  });
}

export const tiptapContentSchema = z.object({
  type: z.string(),
  content: z.array(z.any()),
});

export type TiptapContent = z.infer<typeof tiptapContentSchema>;
